import Flickity from 'flickity';
import wheel from 'wheel';
import normalizeWheel from 'normalize-wheel';
import Events from '@utilities/events';

function initSliders() {

		let carousel = [...document.querySelectorAll('[js-hook-slider]')];

		console.log(carousel.length);

		if(carousel.length){
            var flkty = new Flickity('[js-hook-slider]', {
                contain: true,
                imagesLoaded: true,
                lazyLoad : true,
                dragThreshold: 100,
                selectedAttraction: 0.15,
                friction: 0.8,
                adaptiveHeight: true,
                prevNextButtons: false,
                wrapAround: true
            });

            let next = document.querySelector('[js-hook-slider-next]');
            let prev = document.querySelector('[js-hook-slider-prev]');

            next.addEventListener('click', function() {
                flkty.next();
            }, false);

            prev.addEventListener('click', function() {
                flkty.previous();
            }, false);

            window.addEventListener( 'load', function() {
                flkty.resize();
            });

		}
}

// Export the navigation init function
export default initSliders;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/dudok.test/frontend/source/utilities/slider.js